<div class="category-header hmf-mt-l hmf-pt-l">
  <p class="hmf-subheader-bold-l hmf-mb-0">Shop by Category</p>
</div>
<div class="category-section">
  <div class="category-row hmf-mt-s hmf-mb-s">
    @for (category of categories; track category; let i = $index) {
      <div>
        <div>
          <a [href]="category.link"><img [src]="category.imgUrl" [alt]="category.title"></a>
        </div>
        <a class="category-label hmf-body-bold-s" [href]="category.link">{{category.title}}</a>
      </div>
    }
  </div>
</div>
